import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { store } from '@/store/store';
import { ref, onMounted, Ref } from 'vue';
import { gsap } from 'gsap';


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomCursor',
  setup(__props) {

const Store = store();

const posX:Ref<number> = ref(0);
const posY:Ref<number> = ref(0);
const mouseWidth:Ref<number> = ref(120);

let mouseElem: HTMLElement | null;

onMounted(() => {
  mouseElem = document.querySelector('.custom-mouse');

  document.addEventListener('mousemove', (e) => {
    posX.value = e.clientX - mouseWidth.value / 2;
    posY.value = e.clientY - mouseWidth.value / 2;

    gsap.to(mouseElem, {
      duration: 0.4,
      x: posX.value,
      y: posY.value,
    });
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["custom-mouse", { active: _unref(Store).getActiveMouse}]),
    style: _normalizeStyle(`height: ${mouseWidth.value}px; width: ${mouseWidth.value}px;`)
  }, [
    _createElementVNode("p", null, _toDisplayString(_unref(Store).getCurrentLang == "GE" ? 'ვრცლად' : 'More'), 1)
  ], 6))
}
}

})